module.exports = __webpack_public_path__ + "static/media/25.fb8dad10.jpg";